@switch (state) {
  @case ('mapped') {
    <span class="chip chip-success">Mapped</span>
  }
  @case ('standard') {
    <span class="chip chip-neutral">Standard fields</span>
  }
  @case ('unmapped') {
    <span class="chip chip-warning"> {{ unmappedFieldCount }} unmapped </span>
  }
  @case ('unreadable') {
    <span class="chip chip-error">File unreadable</span>
  }
  @default {
    <span class="fm-not-applicable" aria-label="Not applicable">&mdash;</span>
  }
}
